<template>
  <div class="dialog">
    <el-dialog
      class="formExportAis"
      :visible.sync="changVisible"
      :modal="false"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="true"
      :before-close="$onClose"
      :destroy-on-close="true"
    >
      <el-form id="form_downloadSurvey" method="post"> </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from "@/config/config";
import * as CApi from "@/api/constant_api.js";
import * as Api from "@/api/api.js";

export default {
  data() {
    return {
      changVisible: false,
      loading: true,
      token: localStorage.getItem("token"),
      logIds: ""
    };
  },
  methods: {
    $onClose(done) {
      done();
    },
    close() {
      this.changVisible = false;
    },
    //页面初始化时加载的事件
    show(survey_id, ids, param) {
      let params = "";
      if (ids) {
        params =
          "?token=" +
          this.token +
          "&survey_id=" +
          survey_id +
          "&answer_ids=" +
          ids;
      } else {
        let endTime = "";
        if (param["filter_end_time"]) {
          endTime = param["filter_end_time"] / 1000 + 86399;
        }
        params =
          "?token=" +
          this.token +
          "&survey_id=" +
          survey_id +
          "&filter_end_time=" +
          endTime +
          "&filter_start_time=" +
          (param["filter_start_time"] / 1000 || "") +
          "&search_student_no=" +
          (param["search_student_no"] || "") +
          "&search_name=" +
          (param["search_name"] || "") +
          "&order=" +
          (param["order"] || "");
      }
      if (survey_id == undefined) return;
      //   if (ids.length == 0) ids = ['all']
      //   this.logIds = JSON.stringify(ids)
      //   console.log(this.logIds)
      this.changVisible = true;
      this.$nextTick(() => {
        const form = document.getElementById("form_downloadSurvey");
        form.action = URL_PATH + CApi.api_exportAnswerList + params;
        form.submit();
        this.close();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.formExportAis {
  visibility: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/survey/surveyExportAnswerList.vue